/**
 * Legacy in-app routes that must always redirect to the active MVP flow,
 * regardless of authentication state. Pure and side-effect free so the redirect
 * decision can be tested without rendering the router.
 */
const LEGACY_APP_REDIRECTS: Record<string, string> = {
  '/app/quick-estimate': '/app/wycena',
};

export function resolveLegacyAppRedirect(pathname: string): string | null {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  return LEGACY_APP_REDIRECTS[normalized] ?? null;
}
